// extracted by mini-css-extract-plugin
module.exports = {"quizFrame":"Quiz__quizFrame__gnNZE"};